__turbopack_context__.v({
  "className": "instrument_serif_b2396f85-module__bVXjVW__className",
  "variable": "instrument_serif_b2396f85-module__bVXjVW__variable",
});
